import type ToggleButtonProperties from "./ToggleButton.properties.ts";
import { useState } from "react";
import styles from "./ToggleButton.module.css";

export default function ToggleButtonView(props: ToggleButtonProperties) {
  const [isOn, setIsOn] = useState<boolean>(props.defaultOn);
  const handleClick = () => {
    const next = !isOn;
    setIsOn(next);
    props.onToggle(next);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={
        isOn ? styles.toggleButtonEnabled : styles.toggleButtonDisabled
      }
    >
      {isOn ? props.onLabel : props.offLabel}
    </button>
  );
}
